var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"v-contextmenu-group"},[_c('ul',{staticClass:"v-contextmenu-group__menus",style:(_vm.menusStyle)},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }